import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';
import { makeStyles /* Tooltip */ } from '@material-ui/core';
import Tooltip from '@mui/material/Tooltip';

const useStyles = makeStyles((theme) => ({
  customWidth: {
    maxWidth: 1000,
    fontSize: 12,
  },
}));

export default function InfoIconComponent({ docs }) {
  const toolTipclasses = useStyles();

  return (
    <Tooltip
      //disableInteractive
      disableFocusListener
      disableTouchListener
      title={docs}
      classes={{ tooltip: toolTipclasses.customWidth }}
    >
      <IconButton size="small" edge="start" color="primary">
        <InfoIcon
          size="small"
          style={{
            width: 15,
            height: 15,
            //color: "white",
            //backgroundColor: "black",
            padding: 0,
          }}
        />
      </IconButton>
    </Tooltip>
  );
}
